import React, { memo, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Marker } from "react-map-gl/mapbox";
import { formatCurrency } from "../../../helpers";

const MunicipalityMarkers = memo(function MunicipalityMarkers({
  markers,
  visibleMunicipalityValueType,
}) {
  const { t } = useTranslation();
  // Memoize the marker elements to prevent unnecessary re-renders
  const markerElements = useMemo(() => {
    if (!markers || markers.length === 0) return null;

    // Don't show markers if "none" is selected
    if (visibleMunicipalityValueType === "none") return null;

    return markers.map((marker, i) => {
      const {
        centroid_lon: lng,
        centroid_lat: lat,
        properties_count,
        total_capital_at_risk,
        total_contract_price,
        id, // Use id as key instead of index for better performance
      } = marker;

      const value =
        visibleMunicipalityValueType === "capital"
          ? formatCurrency(total_capital_at_risk)
          : visibleMunicipalityValueType === "price"
            ? formatCurrency(total_contract_price)
            : properties_count;

      return (
        <Marker key={id || i} latitude={lat} longitude={lng} anchor="center">
          <div
            aria-label={t("portfolioMap.markerAriaLabel", { index: i + 1 })}
            style={{
              borderRadius: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "#64b2e6",
              color: "#fff",
              fontWeight: 600,
              fontSize: 14,
              lineHeight: 1,
              padding: "4px 8px",
              border: "2px solid #fff",
              boxShadow: "0 2px 6px rgba(0,0,0,.3)",
              pointerEvents: "auto",
              userSelect: "none",
            }}
          >
            {value}
          </div>
        </Marker>
      );
    });
  }, [markers, visibleMunicipalityValueType, t]);

  return <>{markerElements}</>;
});

export default MunicipalityMarkers;
